export const ACTION_IDS = {
	REFUND_TOURNAMENT: 'refundTournament'
};

export const ACTION_LABELS = {
	[ACTION_IDS.REFUND_TOURNAMENT]: 'Refund Tournament'
};
